import { render, staticRenderFns } from "./GFEMRFMJ.vue?vue&type=template&id=54132a18&scoped=true"
import script from "./GFEMRFMJ.vue?vue&type=script&lang=js"
export * from "./GFEMRFMJ.vue?vue&type=script&lang=js"
import style0 from "./GFEMRFMJ.vue?vue&type=style&index=0&id=54132a18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54132a18",
  null
  
)

export default component.exports